<template>
      <v-col
        :cols="elementColWidth"
      >
        <v-hover v-slot="{ hover }">
          <v-card>
            <v-card-title
              v-text="elementTitle"
            ></v-card-title>
            <v-card-text>
              <RowElementText
                v-if="isElementTextType(rowIndex, elementIndex)"
                :element-data="elementData"
                :element-index="elementIndex"
                :row-index="rowIndex"
              />
              <RowElementImage
                v-if="isElementAnyImageType"
                :element-data="elementData"
                :element-index="elementIndex"
                :row-index="rowIndex"
              />
              <RowElementEmpty
                v-if="isElementEmptyType(rowIndex, elementIndex)"
                :element-data="elementData"
                :element-index="elementIndex"
                :row-index="rowIndex"
              />
            </v-card-text>
            <v-card-actions
              v-if="hover"
              class="card-actions"
            >
              <v-btn
                :disabled="!computedIsElementMovableLeft"
                icon
                @click.stop="moveElement({
                  rowIndex,
                  fromIndex: elementIndex,
                  toIndex: elementIndex - 1
                })"
              >
                <v-icon
                  color="blue"
                >
                  mdi-menu-left
                </v-icon>
              </v-btn>
              <v-btn
                :disabled="!computedIsElementMovableRight"
                icon
                @click.stop="moveElement({
                  rowIndex,
                  fromIndex: elementIndex,
                  toIndex: elementIndex + 1
                })"
              >
                <v-icon
                  color="blue"
                >
                  mdi-menu-right
                </v-icon>
              </v-btn>
              <v-tooltip
                v-if="isElementImageNotEmpty"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click.stop="clearImageWithConfirmation"
                  >
                    <v-icon
                      color="blue"
                    >
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                  clear image
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RowElementText from './RowElementText.vue';
import RowElementImage from './RowElementImage.vue';
import RowElementEmpty from './RowElementEmpty.vue';

export default {
  name: 'RowElement',
  components: {
    RowElementText,
    RowElementEmpty,
    RowElementImage,
  },

  props: {
    elementData: {
      type: Object,
    },

    elementIndex: {
      type: Number,
    },

    rowIndex: {
      type: Number,
    },
  },

  data: () => ({
  }),

  methods: {
    ...mapActions({
      deleteElement: 'microsite/deleteElement',
      clearElement: 'microsite/clearElement',
      moveElement: 'microsite/moveElement',
      setElementToImage: 'microsite/setElementToImage',
    }),

    clearItemWithConfirmation() {
      this.$confirm('Are you sure you want to clear the item?').then((res) => {
        if (!res) return;

        this.clearElement({ rowIndex: this.rowIndex, elementIndex: this.elementIndex });
      });
    },

    clearImageWithConfirmation() {
      this.$confirm('Are you sure you want to clear the image?').then((res) => {
        if (!res) return;

        this.setElementToImage({ rowIndex: this.rowIndex, elementIndex: this.elementIndex });
      });
    },
  },

  computed: {
    ...mapGetters({
      rowLength: 'microsite/rowLength',
      isRowFull: 'microsite/isRowFull',
      isElementMovableRight: 'microsite/isElementMovableRight',
      isElementMovableLeft: 'microsite/isElementMovableLeft',
      isElementRemovable: 'microsite/isElementRemovable',
      isElementClearable: 'microsite/isElementClearable',
      isElementEmptyType: 'microsite/isElementEmptyType',
      isElementImageType: 'microsite/isElementImageType',
      isElementLeadImageType: 'microsite/isElementLeadImageType',
      isElementTextType: 'microsite/isElementTextType',
    }),

    isElementAnyImageType() {
      // eslint-disable-next-line max-len
      return this.isElementImageType(this.rowIndex, this.elementIndex) || this.isElementLeadImageType(this.rowIndex, this.elementIndex);
    },

    isElementImageNotEmpty() {
      return this.isElementAnyImageType
        && (this.elementData.cropped !== null
      || this.elementData.public_link !== null);
    },

    computedIsRowFull() {
      return this.isRowFull(this.rowIndex);
    },

    computedIsElementMovableRight() {
      return this.isElementMovableRight(this.rowIndex, this.elementIndex);
    },

    computedIsElementMovableLeft() {
      return this.isElementMovableLeft(this.elementIndex);
    },

    elementTitle() {
      return this.isElementEmptyType(this.rowIndex, this.elementIndex) ? 'select type' : this.elementData.type;
    },

    elementColWidth() {
      if (!this.isElementImageType(this.rowIndex, this.elementIndex)) {
        return false;
      }

      if (this.rowLength(this.rowIndex) === 1) {
        return false;
      }

      return 4;
    },
  },
};
</script>

<style scoped>
.card-actions {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}
</style>
